export default 'Or drop files';